import { Language } from "@/components/Inputs/LanguagePicker/Language.ts";
import { useTranslation } from "react-i18next";

export const useIsCroatian = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language as Language;
  return currentLanguage === Language.HR;
};
